import Rails from "@rails/ujs";

export default class AdministrativeFilesIndex {

    constructor() {
        this.validation = null;
        this.validation_password = null;
        this.bindEvents();
        this.init();
        //window.application.setOnDataChangeListener(this);
    }

    init(){

        $.validator.addMethod("phone_number_fr", function(value, element) {
            let val = value.replace(/ /g, '');
            return val.match(/[0-9]/g) && value.replace(/ /g, '').length === 10 && (value.charAt(0) === "0");
        }, I18n.t('common.js_validation.phone_number_fr'));

        $.validator.addMethod("password_validation", function( value, element ) {
            return value.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,70}$/g) && value.length >= 8;
        }, I18n.t('common.js_validation.password_validation'));

        this.validation_personal_information();
        this.validation_change_password();
        if($('.files-nav a.active').length){
            $('.files-nav a.active').tab('show');
        }
    }

    bindEvents() {
        $("#driving_instructor_profile_image").on('change', (event) => {
            const file = event.target.files[0];
            if(file && this.valid_file(file)){
                this.previewFile(file);
                this.uploadProfileImage(file, $(event.target).data('url'));
            }
        });

        $(document).ready(() => {
            this.validation.form();
        })

        const $description = $("#driving_instructor_instructor_description");
        const autosize = (el) => {
            if(!el){ return; }
            el.style.height = 'auto';
            el.style.height = `${el.scrollHeight}px`;
        };

        autosize($description.get(0));
        this.updateDescriptionLabel($description);
        $description.on('input', (e) => {
            this.updateDescriptionLabel($(e.target));
            autosize(e.target);
        });

        $("input[id^=id_file_]").change(this.handleDocs);
    }

    updateDescriptionLabel($element) {
        if (!$element.length) return;
        const length = $element.val().length;
        const $label = $("label[for=driving_instructor_instructor_description]");
        $label.toggleClass("text-danger", length >= 1200);
        $label.text(I18n.t("monitors.administrative_files.personal_info.description", {number: length}));
    }

    onDataChanged(data) {
    }

    onDestroy() {
    }

    previewFile(file) {
        let reader = new FileReader();

        reader.onload = function(e) {
            $('#profile_image_preview').attr('src', e.target.result);
        }
        //this.file = file;
        reader.readAsDataURL(file); // convert to base64 string
    }

    validation_personal_information() {
        let validation_options = {
            rules: {
                "driving_instructor[phone_number]":{
                    required: true,
                    phone_number_fr: true
                },
                "driving_instructor[last_name]":{
                    required: true
                },
                "driving_instructor[first_name]":{
                    required: true
                },
                "driving_instructor[birth_date]":{
                    required: true
                },
                "driving_instructor[birth_place]":{
                    required: true
                },
                "driving_instructor[email]":{
                    required: true,
                    email: true
                },
                "driving_instructor[address_line1]":{
                    required: true
                },
                "driving_instructor[instructor_description]":{
                    required: true,
                    maxlength: 1200
                },

            },
            errorClass: 'is-invalid',
            errorElement : 'div',
            errorLabelContainer: '.invalid-feedback',
            ignore: [],
            focusInvalid: false,
            invalidHandler: function(form, validator) {

                if (!validator.numberOfInvalids())
                    return;


                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).parent().offset().top - 100
                }, 1000);

            }
        }

        if(I18n.locale !== 'en'){
            validation_options.messages = require("jquery-validation/dist/localization/messages_"+I18n.locale);
        }

        this.validation = $("#files_form").validate(validation_options);
    }

    validation_change_password() {

        let validation_options = {
            rules: {
                "driving_instructor[current_password]":{
                    required: true
                },
                "driving_instructor[password]":{
                    required: true,
                    password_validation: true
                },
                "driving_instructor[password_confirmation]":{
                    required: true,
                    equalTo: "#driving_instructor_password"
                }
            },
            errorClass: 'is-invalid',
            errorElement : 'div',
            errorLabelContainer: '.invalid-feedback',
            ignore: [],
            focusInvalid: false,
            invalidHandler: function(form, validator) {

                if (!validator.numberOfInvalids())
                    return;


                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).parent().offset().top - 100
                }, 1000);

            }
        }

        if(I18n.locale !== 'en'){
            validation_options.messages = require("jquery-validation/dist/localization/messages_"+I18n.locale);
        }

        this.validation_password = $("#monitor_password").validate(validation_options);
    }

    handleDocs(e) {
        let el = e.currentTarget;

        if(el.files[0] !== undefined){
            let id = $(el).data('id');
            let $doc = $('#document_'+id);
            $doc.find('.file-input').addClass('d-none');
            $doc.find('.spinner-border').removeClass('d-none');

            let formData = new FormData();
            formData.append("driving_instructor_document[document]", el.files[0]);

            Rails.ajax({
                url: '/monitor/administrative_files/'+$(el).data("id")+'/upload_file',
                type: 'POST',
                data: formData,
                success: function(data) {
                    let $doc = $('#document_'+data['element_id']);
                    $doc.removeClass('file_required').addClass('uploaded');
                    $doc.find('.spinner-border').addClass('d-none');
                    $('#error_message_'+data['element_id']).text('');
                    $('#doc_status_' + data['element_id']).replaceWith($(data.doc_status_tag));
                    $('#file_input_' + data['element_id']).addClass('d-none');
                    application.successNotification("Fichier transmis à l’équipe");
                },
                error: function(err) {
                    let data = err.responseJSON;
                    let $doc = $('#document_'+(data && data['element_id'] ? data['element_id'] : id));
                    $doc.addClass('file_required').removeClass('uploaded');
                    $('#error_message_'+(data && data['element_id'] ? data['element_id'] : id)).text(data ? data['error_message'] : '');
                    $doc.find('.spinner-border').addClass('d-none');
                    $doc.find('.file-input').removeClass('d-none');
                    application.errorNotification("Erreur, fichier non transmis à l’équipe");
                }
            });
        }
    }

    valid_file(file) {
        if(!['image/jpg','image/jpeg','image/png'].includes(file.type)){
            $("#profile_image_error").remove();
            $(".personal-info-container")
                .css('border', '2px solid red')
                .after(
                    `<div id="profile_image_error">
                        ${I18n.t('students.administrative_files.personal_info.invalid_image_format', { formats: 'JPG, JPEG, PNG' })}
                    </div>`
                );
            $("#driving_instructor_profile_image").val('');
            return false;
        }
        $("#profile_image_error").remove();
        $(".personal-info-container").css('border', '');
        return true;
    }

    uploadProfileImage(file, url){
        if(!url){ return; }
        const formData = new FormData();
        formData.append('driving_instructor[profile_image]', file);

        Rails.ajax({
            url: url,
            type: 'PATCH',
            data: formData,
            success: function(response){
                if(response.success){
                    if(response.image_url){
                        $('#profile_image_preview').attr('src', response.image_url);
                    }
                    application.successNotification('Photo mise à jour avec succès.');
                }else{
                    application.errorNotification('Une erreur est survenue lors de la mise à jour de l\'image.');
                }
            },
            error: function(){
                application.errorNotification('Une erreur est survenue lors de la mise à jour de l\'image.');
            }
        })
    }

}